import { Box } from 'braid-design-system';
import type { ReactNode } from 'react';

import * as styles from './LoadingPlaceholder.css';

export const LoadingPlaceholder = ({ children }: { children: ReactNode }) => (
  <Box component="span" display="flex">
    <BlockLoadingPlaceholder>{children}</BlockLoadingPlaceholder>
  </Box>
);

export const BlockLoadingPlaceholder = ({
  children,
}: {
  children: ReactNode;
}) => (
  <Box
    component="span"
    className={styles.shimmer}
    borderRadius="standard"
    display="inline"
  >
    <Box component="span" style={{ visibility: 'hidden' }}>
      {children}
    </Box>
  </Box>
);

export const LoadingOverlay = () => <Box className={styles.shimmerOverlay} />;
